import React from 'react';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { messages } from '../../messages';
import style from './style.module.less';

/**
 * @param {object} props
 * @param {boolean} [props.disabled]
 * @param {React.ReactNode} [props.disabledTooltipMessage]
 * @param {import('../../../prop-types/intl').MessageDescriptorPropType} [props.message]
 * @param {() => void} props.onPrint
 * @returns {JSX.Element}
 */
export const PrintButton = ({ disabled = false, disabledTooltipMessage = null, message = messages.scanPrintButton, onPrint }) => (
  <div className={style['button-wrapper']}>
    <Button
      className={style['print-button']}
      disabled={disabled}
      disabledTooltipMessage={disabledTooltipMessage}
      onClick={onPrint}
      theme='primary'
    >
      <Text isBold textType={TextType.H2} value={message} />
    </Button>
  </div>
);
